/**
 * Company (tenant) — tipo de servicio contratado y perfil de personalización.
 * El "company" es un `user` con userrole 'company' (no hay modelo aparte).
 */

/**
 * Tipo de servicio que contrata una company. Es el default del `type` de sus
 * expedientes (ver resolveExpedientType). `judicial` NO es un servicio
 * contratable: es un estado al que transiciona un expediente.
 */
const COMPANY_SERVICE_TYPES = {
  ACCOUNT_RECEIVABLE: 'account-receivable',
  EXTRA_JUDICIAL: 'extra-judicial',
};

const ALL_COMPANY_SERVICE_TYPES = Object.values(COMPANY_SERVICE_TYPES);

const COMPANY_SERVICE_TYPE_LABELS = {
  'account-receivable': 'Gestión propia',
  'extra-judicial': 'Extrajudicial (recobro externo)',
};

/**
 * Campos del perfil de empresa (personalización del AI). Whitelist única usada
 * tanto por el endpoint de update como por el render del frontend. Todos texto
 * libre y opcionales.
 */
const COMPANY_PROFILE_FIELDS = [
  'description', // Descripción de la empresa
  'debtor_profile', // Descripción del tipo de cliente / deudor
  'ar_management_time', // Tiempo en gestión de AR
  'frequent_disputes', // Disputas más frecuentes y vías de solución
  'discount_policy', // Política de quitas
  'payment_plan_policy', // Política de planes de pago
  'payment_link', // Forma de pago: link de pago
  'iban', // Forma de pago: IBAN
  'contact_names', // Nombres de contacto con el cliente
  // 🔴 Qué pierde el deudor además del dinero.
  //
  // Faltaba y es lo único que el agente puede decir que no sea «acciones
  // legales». En una academia el impago cierra el acceso al curso, y eso pesa
  // mucho más y llega mucho antes que una denuncia: es concreto, es inmediato y
  // es reversible pagando. Lo pidió Edgar el 14/09/2026 para Learning Heroes y
  // Tattoox, pero no es de ellos: lo tiene cualquier cliente que preste un
  // servicio que se puede cortar.
  'non_payment_consequences',
];

/**
 * Labels ES para los campos del perfil (UI).
 */
const COMPANY_PROFILE_FIELD_LABELS = {
  description: 'Descripción de la empresa',
  debtor_profile: 'Tipo de cliente / deudor',
  ar_management_time: 'Tiempo en gestión de AR',
  frequent_disputes: 'Disputas frecuentes y vías de solución',
  discount_policy: 'Política de quitas',
  payment_plan_policy: 'Política de planes de pago',
  payment_link: 'Link de pago',
  iban: 'IBAN',
  contact_names: 'Nombres de contacto',
  non_payment_consequences: 'Qué pierde el deudor si no paga (además del dinero)',
};

module.exports = {
  COMPANY_SERVICE_TYPES,
  ALL_COMPANY_SERVICE_TYPES,
  COMPANY_SERVICE_TYPE_LABELS,
  COMPANY_PROFILE_FIELDS,
  COMPANY_PROFILE_FIELD_LABELS,
};
